import React from 'react';
import PropTypes from 'prop-types';
// TODO: Code split with React.lazy
import DateFilter from '../components/DateFilter';
import FuzzyFilter from '../components/FuzzyFilter';
import MultiSelect from '../components/MultiSelect';
import NumberFilter from '../components/NumberFilter';

const filterFunction = (props) => {
  if (props.column.type === 'number') {
    return <NumberFilter column={props.column} />;
  }
  if (props.column.type === 'date') {
    return <DateFilter column={props.column} />;
  }
  if (props.column.type === 'multiselect' || props.column.type === 'typeaheadMultiSelect') {
    return <MultiSelect column={props.column} />;
  }
  // NOTE: if no type specified (or type is not handled in mobile yet) then handle as fuzzy filter
  return <FuzzyFilter column={props.column} />;
};

filterFunction.propTypes = {
  column: PropTypes.shape({
    type: PropTypes.string
  }).isRequired
};

export default filterFunction;
